import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Loading from 'components/Loading';
import Page from 'containers/Page';
import auth from 'lib/auth';

const GatedContentPage = ({ router, destination, viewer }) => {
  useEffect(() => {
    const url = `/${destination}`;
    if (viewer?.loggedIn) {
      router.push(url);
    } else {
      auth.login(url);
    }
  }, [destination, router, viewer]);

  return (
    <Page title='Redirecting...' viewer={viewer}>
      {!viewer?.loggedIn ? (
        <Loading>
          <div>
            Redirecting you to login before viewing your content, one moment...
          </div>
        </Loading>
      ) : (
        <div />
      )}
    </Page>
  );
};

GatedContentPage.propTypes = {
  router: PropTypes.object.isRequired,
  destination: PropTypes.string.isRequired,
  relay: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default GatedContentPage;
